var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmarthatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6568",
    "data-name": "Group 6568",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.875,
    height: 14.875,
    viewBox: "0 0 14.875 14.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_77271",
    "data-name": "Path 77271",
    d: "M0,30.951H2.427V28.082L0,26.358Z",
    transform: "translate(0 -16.076)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77272",
    "data-name": "Path 77272",
    d: "M10.547,35.453h2.411L10.547,33.74Z",
    transform: "translate(-6.433 -20.579)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77273",
    "data-name": "Path 77273",
    d: "M10.648,9.192v2.592l8.387,5.987v2.709h2.334V16.8l-8.378-5.848V9.192Z",
    transform: "translate(-6.494 -5.607)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77274",
    "data-name": "Path 77274",
    d: "M32.184,9.19V13L34.5,14.508V9.19Z",
    transform: "translate(-19.63 -5.605)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77275",
    "data-name": "Path 77275",
    d: "M8.372,2.009V4.444l2.321,1.512V2.009ZM0,0V2.009H14.876V0Z",
    transform: "translate(-0.001)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77276",
    "data-name": "Path 77276",
    d: "M0,9.19v4.5l8.353,5.892v.895h2.3V18.557L2.327,12.8V9.19Z",
    transform: "translate(0 -5.605)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmarthatch);
export default __webpack_public_path__ + "static/media/smarthatch.f1510938c40448ba6720478113ecebbb.svg";
export { ForwardRef as ReactComponent };